/**
 * Integration Marketplace Demo — previously a floating reset/exit badge.
 *
 * THROWAWAY DEMO CODE (see ./README.md). The visible reset/exit affordance now
 * lives in the global Cmd+K demo command, and the "demo is on" cue is the avatar
 * ring in the sidebar, so this renders nothing. Kept as the route mount point /
 * clean deletion boundary — remove its `<ImDemoControls />` in route.tsx when
 * deleting the IM demo.
 */

export function ImDemoControls() {
  return null;
}
